module.exports = __webpack_public_path__ + "img/hk.6a78ee1b.png";